import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space } from 'antd';

// svgs
import { ReactComponent as IconAddOutlined } from '../../images/add-outline.svg';
import { ReactComponent as IconUpload } from '../../images/upload.svg';

// components, keys, and utils
import { BrowseDataProductFilters } from '../entity/shared/containers/profile/FilterOptions/FilterOptions';
import FilterDropdown from '../entity/shared/components/FilterDropdown/FilterDropdown';

// generated
import { DataDataProductTable } from './BrowseDataProductTableType';
import { FilterOperator, Maybe } from '../../types.generated';

export interface BrowseDataProductHeaderProps {
    onAddDataProduct?: () => void;
    onImportDataProduct?: () => void;
    data: DataDataProductTable[];
    onResetFilter?: (key: string) => void;
    onApplyFilter?: (key: string, value: string | number, condition?: Maybe<FilterOperator>, negated?: boolean) => void;
    onSearch?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BrowseDataProductHeader: React.FC<BrowseDataProductHeaderProps> = ({
    onImportDataProduct,
    onAddDataProduct,
    onResetFilter,
    onApplyFilter,
    data,
    onSearch,
}: BrowseDataProductHeaderProps) => {
    return (
        <>
            <Row gutter={8} className="px-3 pt-2 mx-0">
                <Col flex="auto">
                    <Input
                        size="middle"
                        placeholder="Search by name or description"
                        prefix={<SearchOutlined />}
                        onChange={onSearch}
                    />
                </Col>
                <Col flex="none">
                    <Button type="primary" className="f-btn-underline" onClick={onImportDataProduct}>
                        <IconUpload />
                        <span>Import</span>
                    </Button>
                </Col>
                <Col flex="none">
                    <Button type="primary" className="f-btn-underline" onClick={onAddDataProduct}>
                        <IconAddOutlined />
                        <span>Add Data Product</span>
                    </Button>
                </Col>
            </Row>
            <Space className="px-2 py-3 f-layout-wrap-xs" size="small">
                {BrowseDataProductFilters.map((item) => (
                    <FilterDropdown
                        {...item}
                        key={item.id}
                        disabled={!data}
                        onApplyFilter={onApplyFilter}
                        onResetFilter={onResetFilter}
                    />
                ))}
            </Space>
        </>
    );
};
